module.exports = __webpack_public_path__ + "assets/img/PersonalRankingList.74cf13f1.png";